import type { PublicService } from "../types";

/** Uma seleção com preço oculto não é um total fechado, mesmo se parte for pública. */
export function buildGuestServicePriceLabel(
  services: PublicService[],
  getPrice: (service: PublicService) => number | null
): string {
  const prices = services.map(getPrice);
  if (
    !services.length ||
    prices.some((price) => price == null || !Number.isFinite(price))
  ) {
    return "Valor dos serviços a confirmar no atendimento.";
  }
  const total = prices.reduce<number>((sum, price) => sum + (price || 0), 0);
  const value = total.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  return `Valor avulso dos serviços: ${services.some((service) => service.priceStartingFrom) ? "a partir de " : ""}${value}`;
}
